<template>
  <div class="estimate-page-wrapper m-left-page">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#0f172a"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#1e293b" right :timeout="timeout">
      <div class="d-flex align-center justify-space-between text-white" style="font-size: 13px;">
        <span>{{ msg }}</span>
        <v-btn small icon text @click="showsnackbar = false" class="ml-2">
          <v-icon small color="white">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <!-- Top Executive Header -->
    <v-card flat class="estimate-header-card pa-4 mb-4 rounded-lg">
      <v-layout wrap align-center justify-space-between>
        <v-flex xs12 sm7 md6 class="d-flex align-center flex-wrap">
          <v-btn icon small class="mr-2 header-back-btn" @click="$router.push('/SalesList')">
            <v-icon small color="#475569">mdi-arrow-left</v-icon>
          </v-btn>
          <div class="d-flex align-center mr-3">
            <v-icon color="#0f172a" class="mr-2" size="22">mdi-file-document-edit-outline</v-icon>
            <span class="estimate-title-tag">EDIT ESTIMATE</span>
          </div>
          <div class="d-flex align-center">
            <v-text-field
              v-model="billPrefix"
              placeholder="Prefix"
              outlined
              dense
              hide-details
              class="estimate-prefix-field mr-2"
              color="#9a6b27"
            ></v-text-field>
            <div class="estimate-number-pill">
              <v-icon small color="#64748b" class="mr-1">mdi-pound</v-icon>
              <span>{{ estno }}</span>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm5 md6 class="d-flex align-center justify-end flex-wrap mt-2 mt-sm-0">
          <div class="estimate-date-badge mr-3" v-if="date">
            <v-icon small color="#64748b" class="mr-1">mdi-calendar-range</v-icon>
            <span>{{ date }}</span>
          </div>
          <div class="salesman-container">
            <v-select
              v-model="salesmenCode"
              :items="salesmanOptions"
              item-text="label"
              item-value="staffCode"
              placeholder="Select Salesman"
              dense
              outlined
              hide-details
              color="#9a6b27"
              class="salesman-select"
            ></v-select>
          </div>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout wrap>
      <v-flex xs12>
        <!-- Customer Details Card -->
        <v-card flat class="customer-card rounded-lg mb-4">
          <div class="customer-card-header px-4 py-3 d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-icon small color="#475569" class="mr-2">mdi-account-outline</v-icon>
              <span class="card-heading">Customer Details</span>
            </div>
            <v-btn
              small
              outlined
              color="#475569"
              class="rounded-lg text-capitalize erp-btn-secondary"
              @click="addcustomerdialogue = true"
            >
              <v-icon left small>mdi-account-plus</v-icon>
              Add Customer
            </v-btn>
          </div>
          <v-divider></v-divider>
          <div class="pa-4">
            <div class="customer-grid">
              <div class="customer-field-col">
                <label class="erp-field-label">Customer Name</label>
                <v-autocomplete
                  v-if="customerList"
                  color="#9a6b27"
                  @input="customerdetails()"
                  @update:search-input="searchCustomerByKeyword"
                  :items="customerList"
                  v-model="customerName"
                  placeholder="Search name or phone..."
                  item-text="customerName"
                  item-value="_id"
                  :filter="customerFilter"
                  outlined
                  hide-details
                  dense
                  class="erp-field"
                  prepend-inner-icon="mdi-magnify"
                ></v-autocomplete>
              </div>
              <div class="customer-field-col">
                <label class="erp-field-label">Address</label>
                <v-text-field
                  type="text"
                  v-model="address"
                  outlined
                  disabled
                  placeholder="Address"
                  dense
                  hide-details
                  class="erp-field erp-readonly"
                ></v-text-field>
              </div>
              <div class="customer-field-col">
                <label class="erp-field-label">City</label>
                <v-text-field
                  type="text"
                  v-model="city"
                  outlined
                  disabled
                  placeholder="City"
                  dense
                  hide-details
                  class="erp-field erp-readonly"
                ></v-text-field>
              </div>
              <div class="customer-field-col">
                <label class="erp-field-label">Mobile Number</label>
                <v-text-field
                  type="number"
                  v-model="contact"
                  outlined
                  disabled
                  placeholder="Contact"
                  dense
                  hide-details="auto"
                  class="erp-field erp-readonly"
                ></v-text-field>
              </div>
            </div>
          </div>
        </v-card>

        <!---------------------ITEM DETAILS------------------------->
        <ESaddItem
          v-bind:title="estno"
          :datareload="datareload"
          :customerName="customerName"
          :contact="contact"
          @stepper="winStepper"
        />

        <oldGold
          v-if="itempresent == true"
          v-bind:title2="billData"
          @stepper="winStepper"
        />

        <returnGold
          v-if="itempresent == true"
          v-bind:title3="billData"
          @stepper="winStepper"
        />

        <div class="d-flex justify-space-between align-center py-4" v-if="itempresent == true">
          <v-btn outlined color="#475569" class="text-capitalize px-4" @click="$router.push('/SalesList')">
            <v-icon left small>mdi-arrow-left</v-icon>
            Back to List
          </v-btn>
          <v-btn
            large
            dark
            class="generate-estimate-btn text-capitalize px-6 elevation-1"
            @click="validate()"
          >
            <v-icon left>mdi-file-document-check-outline</v-icon>
            Update Estimate
          </v-btn>
        </div>

        <!-- Add Customer Dialog -->
        <v-dialog width="640px" v-model="addcustomerdialogue">
          <v-form v-model="addcat" ref="addcat" @submit.prevent>
            <v-card class="rounded-lg erp-modal-card">
              <div class="modal-top-bar px-6 py-4 d-flex align-center justify-space-between">
                <div>
                  <div class="modal-title">Add Customer</div>
                  <div class="modal-subtext">Enter customer profile details</div>
                </div>
                <v-btn icon small @click="addcustomerdialogue = false; resetForm()">
                  <v-icon color="#64748b">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-divider></v-divider>
              <div class="px-6 py-4">
                <v-row dense>
                  <v-col cols="12" sm="6" class="py-1">
                    <label class="erp-field-label">Customer Name <span class="required-star">*</span></label>
                    <v-text-field
                      type="text"
                      placeholder="Enter Full Name"
                      v-model="newCustomer"
                      outlined
                      dense
                      :rules="[rules.required]"
                      color="#9a6b27"
                      hide-details="auto"
                      class="erp-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="py-1">
                    <label class="erp-field-label">Phone Number <span class="required-star">*</span></label>
                    <v-text-field
                      placeholder="10-digit number"
                      v-model="newContact"
                      outlined
                      :rules="phoneRules"
                      color="#9a6b27"
                      dense
                      type="number"
                      hide-details="auto"
                      class="erp-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="py-1">
                    <label class="erp-field-label">PAN Number</label>
                    <v-text-field
                      type="text"
                      placeholder="e.g. ABCDE1234F"
                      v-model="newCustomerPAN"
                      outlined
                      dense
                      :rules="panRules"
                      color="#9a6b27"
                      hide-details="auto"
                      class="erp-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="py-1">
                    <label class="erp-field-label">Aadhaar Number</label>
                    <v-text-field
                      type="number"
                      placeholder="12-digit number"
                      v-model="newCustomerAadhar"
                      outlined
                      dense
                      :rules="aadhaarRules"
                      color="#9a6b27"
                      hide-details="auto"
                      class="erp-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="py-1">
                    <label class="erp-field-label">City</label>
                    <v-text-field
                      color="#9a6b27"
                      type="text"
                      placeholder="Enter City"
                      v-model="newCity"
                      outlined
                      dense
                      hide-details
                      class="erp-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="py-1">
                    <label class="erp-field-label">Pin Code</label>
                    <v-text-field
                      color="#9a6b27"
                      type="number"
                      placeholder="6-digit PIN"
                      v-model="newpinNumber"
                      outlined
                      :rules="pinRules"
                      dense
                      hide-details="auto"
                      class="erp-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-1">
                    <label class="erp-field-label">Address</label>
                    <v-textarea
                      color="#9a6b27"
                      rows="2"
                      placeholder="Enter Address"
                      v-model="newAddress"
                      outlined
                      dense
                      hide-details
                      class="erp-field"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </div>
              <v-divider></v-divider>
              <div class="px-6 py-3 d-flex justify-end gap-2">
                <v-btn text color="#64748b" class="text-capitalize mr-2" @click="addcustomerdialogue = false; resetForm()">
                  Cancel
                </v-btn>
                <v-btn dark class="erp-action-btn text-capitalize px-4" :disabled="!addcat" @click="addCustomer()">
                  Save Customer
                </v-btn>
              </div>
            </v-card>
          </v-form>
        </v-dialog>

        <!-- Quotation Preview Dialog -->
        <v-dialog
          style="z-index:3000;"
          v-model="preview"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card tile height="100%" class="preview-page-card">
            <!-- Modal Header -->
            <div class="preview-header preview-head-bar px-6 py-4 d-flex align-center justify-space-between">
              <div class="d-flex align-center">
                <v-icon color="#0f172a" class="mr-2">mdi-file-document-outline</v-icon>
                <span class="preview-title">ESTIMATE / QUOTATION PREVIEW</span>
              </div>
              <v-btn icon @click="preview = false">
                <v-icon color="#64748b">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>

            <div class="pa-6 preview-scroll-area preview-body m-left-page">
              <!-- Meta Cards (Customer & Estimate Info) -->
              <v-row dense class="mb-4">
                <v-col cols="12" md="6">
                  <v-card outlined class="pa-4 preview-info-card h-100">
                    <div class="preview-info-heading mb-3">
                      <v-icon small color="#64748b" class="mr-1">mdi-account-outline</v-icon>
                      Customer Details
                    </div>
                    <div class="preview-info-row" v-if="previewList2.customerName">
                      <span class="info-label">Customer Name:</span>
                      <span class="info-val font-weight-bold">{{ previewList2.customerName }}</span>
                    </div>
                    <div class="preview-info-row" v-if="previewList2.mobileNumber">
                      <span class="info-label">Contact:</span>
                      <span class="info-val">{{ previewList2.mobileNumber }}</span>
                    </div>
                    <div class="preview-info-row" v-if="previewList2.customerId && previewList2.customerId.address">
                      <span class="info-label">Address:</span>
                      <span class="info-val">{{ previewList2.customerId.address }}</span>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card outlined class="pa-4 preview-info-card h-100">
                    <div class="preview-info-heading mb-3">
                      <v-icon small color="#64748b" class="mr-1">mdi-information-outline</v-icon>
                      Estimate Information
                    </div>
                    <div class="preview-info-row" v-if="previewList2.billNo">
                      <span class="info-label">Estimate No:</span>
                      <span class="info-val font-weight-bold">{{ (previewList2.billPrefix || '') + previewList2.billNo }}</span>
                    </div>
                    <div class="preview-info-row" v-if="previewList2.staffCode">
                      <span class="info-label">Salesman / Staff:</span>
                      <span class="info-val">{{ previewList2.staffCode }}</span>
                    </div>
                    <div class="preview-info-row" v-if="previewList2.create_date">
                      <span class="info-label">Date:</span>
                      <span class="info-val">{{ formatDate(previewList2.create_date) }}</span>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Bill Items Table -->
              <div v-if="previewList1 && previewList1.length > 0" class="mb-4">
                <div class="preview-table-title mb-2">
                  <v-icon small color="#475569" class="mr-1">mdi-ring</v-icon>
                  Bill Items ({{ previewList1.length }})
                </div>
                <v-card outlined class="rounded-lg overflow-hidden">
                  <v-simple-table dense class="preview-table m-stack-table m-stack-grid">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">#</th>
                          <th class="text-left">Item</th>
                          <th class="text-left">HSN</th>
                          <th class="text-right">Qty</th>
                          <th class="text-right">Gr. Wt (gm)</th>
                          <th class="text-right">St. Wt (gm)</th>
                          <th class="text-right">Net Wt (gm)</th>
                          <th class="text-right">Making Chg (₹)</th>
                          <th class="text-right">VA (%)</th>
                          <th class="text-right">Discount (₹)</th>
                          <th class="text-right">CGST (%)</th>
                          <th class="text-right">SGST (%)</th>
                          <th class="text-right">Total (₹)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, i) in previewList1" :key="i">
                          <td data-label="#">{{ i + 1 }}</td>
                          <td data-label="Item" class="font-weight-medium">
                            <span v-if="value.designId">{{ value.designId.name }} - {{ value.itemId.name }}</span>
                            <span v-else>-</span>
                          </td>
                          <td data-label="HSN">
                            <span v-if="value.designId && value.designId.HSN">{{ value.designId.HSN.hsnCode }}</span>
                            <span v-else>-</span>
                          </td>
                          <td data-label="Qty" class="text-right">{{ value.quantity || '-' }}</td>
                          <td data-label="Gr. Wt (gm)" class="text-right">{{ (value.grossWeight || 0).toFixed(2) }}</td>
                          <td data-label="St. Wt (gm)" class="text-right">{{ (value.stoneWeight || 0).toFixed(2) }}</td>
                          <td data-label="Net Wt (gm)" class="text-right font-weight-medium">{{ (value.netWeight || 0).toFixed(2) }}</td>
                          <td data-label="Making Chg (₹)" class="text-right">
                            {{ value.adjustedMakingCharge ? (value.adjustedMakingCharge).toFixed(2) : (value.makingCharge ? value.makingCharge.toFixed(2) : '0.00') }}
                          </td>
                          <td data-label="VA (%)" class="text-right">
                            {{ value.valueAddition ? value.valueAddition.toFixed(2) : '0.00' }}
                          </td>
                          <td data-label="Discount (₹)" class="text-right">{{ value.discountAmount ? value.discountAmount.toFixed(2) : '0.00' }}</td>
                          <td data-label="CGST (%)" class="text-right">{{ value.cgst ? value.cgst.toFixed(2) : '0.00' }}</td>
                          <td data-label="SGST (%)" class="text-right">{{ value.sgst ? value.sgst.toFixed(2) : '0.00' }}</td>
                          <td data-label="Total (₹)" class="text-right font-weight-bold">{{ value.amountWithGst ? value.amountWithGst.toFixed(2) : '0.00' }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </div>

              <!-- Old Gold Items Table -->
              <div v-if="previewList3 && previewList3.length > 0" class="mb-4">
                <div class="preview-table-title mb-2">
                  <v-icon small color="#475569" class="mr-1">mdi-swap-horizontal</v-icon>
                  Old Metal Exchange Items ({{ previewList3.length }})
                </div>
                <v-card outlined class="rounded-lg overflow-hidden">
                  <v-simple-table dense class="preview-table m-stack-table m-stack-grid">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">#</th>
                          <th class="text-left">Item</th>
                          <th class="text-center">Metal</th>
                          <th class="text-right">Rate (₹)</th>
                          <th class="text-right">Gr. Wt (gm)</th>
                          <th class="text-right">St. Wt (gm)</th>
                          <th class="text-right">Net Wt (gm)</th>
                          <th class="text-right">Melt (%)</th>
                          <th class="text-right">Amount (₹)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, i) in previewList3" :key="i">
                          <td data-label="#">{{ i + 1 }}</td>
                          <td data-label="Item" class="font-weight-medium">{{ value.itemName || '-' }}</td>
                          <td data-label="Metal" class="text-center">{{ value.metalType || 'Gold' }}</td>
                          <td data-label="Rate (₹)" class="text-right">{{ value.goldRate || 0 }}</td>
                          <td data-label="Gr. Wt (gm)" class="text-right">{{ (value.grossWeight || 0).toFixed(2) }}</td>
                          <td data-label="St. Wt (gm)" class="text-right">{{ (value.stoneWeight || 0).toFixed(2) }}</td>
                          <td data-label="Net Wt (gm)" class="text-right font-weight-medium">{{ (value.netWeight || 0).toFixed(2) }}</td>
                          <td data-label="Melt (%)" class="text-right">{{ value.melt || 0 }}%</td>
                          <td data-label="Amount (₹)" class="text-right font-weight-bold text-success">- ₹ {{ value.itemAmount ? value.itemAmount.toFixed(2) : '0.00' }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </div>

              <!-- Return Items Table -->
              <div v-if="previewList5 && previewList5.length > 0" class="mb-4">
                <div class="preview-table-title mb-2">
                  <v-icon small color="#475569" class="mr-1">mdi-keyboard-return</v-icon>
                  Return Items ({{ previewList5.length }})
                </div>
                <v-card outlined class="rounded-lg overflow-hidden">
                  <v-simple-table dense class="preview-table m-stack-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">#</th>
                          <th class="text-left">Item</th>
                          <th class="text-right">Qty</th>
                          <th class="text-right">Gr. Wt (gm)</th>
                          <th class="text-right">St. Wt (gm)</th>
                          <th class="text-right">Net Wt (gm)</th>
                          <th class="text-right">Return Amt (₹)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, i) in previewList5" :key="i">
                          <td data-label="#">{{ i + 1 }}</td>
                          <td data-label="Item" class="font-weight-medium">
                            <span v-if="value.designId">{{ value.designId.name }} - {{ value.itemId.name }}</span>
                            <span v-else>-</span>
                          </td>
                          <td data-label="Qty" class="text-right">{{ value.quantity || '-' }}</td>
                          <td data-label="Gr. Wt (gm)" class="text-right">{{ (value.grossWeight || 0).toFixed(2) }}</td>
                          <td data-label="St. Wt (gm)" class="text-right">{{ (value.stoneWeight || 0).toFixed(2) }}</td>
                          <td data-label="Net Wt (gm)" class="text-right font-weight-medium">{{ (value.netWeight || 0).toFixed(2) }}</td>
                          <td data-label="Return Amt (₹)" class="text-right font-weight-bold text-success">- ₹ {{ value.itemTotalAmount ? value.itemTotalAmount.toFixed(2) : '0.00' }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </div>

              <!-- Calculation Summary Block & Actions -->
              <div class="d-flex justify-space-between align-center flex-wrap mt-6 pt-4 border-t">
                <v-card outlined class="pa-4 preview-total-card mb-3 mb-md-0 preview-total-wrap">
                  <div class="d-flex justify-space-between py-1" v-if="previewList2.totalAmountWithGst">
                    <span class="summary-label">Bill Items Total:</span>
                    <span class="summary-value">₹ {{ (previewList2.totalAmountWithGst).toFixed(2) }}</span>
                  </div>
                  <div class="d-flex justify-space-between py-1" v-if="previewList2.oldGoldAmount">
                    <span class="summary-label text-success">Old Gold Deduction:</span>
                    <span class="summary-value text-success">- ₹ {{ (previewList2.oldGoldAmount).toFixed(2) }}</span>
                  </div>
                  <div class="d-flex justify-space-between py-1" v-if="returnTotalAmt">
                    <span class="summary-label text-success">Return Deduction:</span>
                    <span class="summary-value text-success">- ₹ {{ (returnTotalAmt).toFixed(2) }}</span>
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div class="d-flex justify-space-between py-1 align-center" v-if="newTotal">
                    <span class="net-total-label">Net Payable Amount:</span>
                    <span class="net-total-value">₹ {{ newTotal }}</span>
                  </div>
                </v-card>

                <div class="d-flex align-center preview-actions">
                  <v-btn outlined color="#64748b" class="mr-3 text-capitalize px-4" @click="preview = false">
                    Close Preview
                  </v-btn>
                  <v-btn dark class="erp-action-btn text-capitalize px-6" @click="saveBill()">
                    <v-icon left>mdi-credit-card-check-outline</v-icon>
                    Proceed to Payment
                  </v-btn>
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>

        <!-- Boarding Rate Query Popup -->
        <v-dialog
          v-model="queryPopUpDialog"
          persistent
          :width="
            $vuetify.breakpoint.name == 'xs'
              ? '100vw'
              : $vuetify.breakpoint.name == 'sm'
              ? '60vw'
              : $vuetify.breakpoint.name == 'md'
              ? '50vw'
              : $vuetify.breakpoint.name == 'lg'
              ? '40vw'
              : '30vw'
          "
          style="z-index: 1000"
        >
          <v-card class="rounded-lg erp-modal-card">
            <div class="modal-top-bar px-6 py-4 d-flex align-center justify-space-between">
              <div>
                <div class="modal-title">Boarding Rate Update</div>
                <div class="modal-subtext">Set current market boarding rates per gram</div>
              </div>
              <v-btn icon small @click="queryPopUpDialog = false">
                <v-icon small color="#64748b">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>
            <div class="pa-6">
              <v-row dense>
                <v-col cols="12" sm="6" class="py-2">
                  <label class="erp-field-label">Thankam Rate (/gm)</label>
                  <v-text-field
                    prefix="₹"
                    v-model="thankamRate"
                    type="number"
                    outlined
                    dense
                    color="#9a6b27"
                    class="erp-field"
                    placeholder="0.00"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-2">
                  <label class="erp-field-label">Silver Rate (/gm)</label>
                  <v-text-field
                    prefix="₹"
                    v-model="silverRate"
                    type="number"
                    outlined
                    dense
                    color="#9a6b27"
                    class="erp-field"
                    placeholder="0.00"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-2">
                  <label class="erp-field-label">Platinum Rate (/gm)</label>
                  <v-text-field
                    prefix="₹"
                    v-model="platinumRate"
                    type="number"
                    outlined
                    dense
                    color="#9a6b27"
                    class="erp-field"
                    placeholder="0.00"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-2">
                  <label class="erp-field-label">Diamond Rate (/ct)</label>
                  <v-text-field
                    prefix="₹"
                    v-model="diamond"
                    type="number"
                    outlined
                    dense
                    color="#9a6b27"
                    class="erp-field"
                    placeholder="0.00"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <div class="px-6 py-3 d-flex justify-end">
              <v-btn dark class="erp-action-btn text-capitalize px-6" @click="EditRate()">
                Save Rates
              </v-btn>
            </div>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import ESaddItem from "../Estimate/ESaddItem";
import oldGold from "../Estimate/oldGold";
import returnGold from "../Estimate/returnGold";

export default {
  components: {
    ESaddItem,
    oldGold,
    returnGold,
  },
  data() {
    return {
      dialog: false,
      gold: "",
      thankamRate: "",
      silverRate: "",
      platinumRate: "",
      diamond: "",
      queryPopUpDialog: false,
      quotation: "1",
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu2: false,
      estno: null,
      value: "",
      newCustomer: null,
      newAddress: null,
      newCity: null,
      newContact: null,
      newpinNumber: null,
      newCustomerPAN: null,
      newCustomerAadhar: null,
      addcustomerdialogue: false,
      addcat: false,
      customerName: null,
      address: null,
      city: null,
      contact: null,
      salesmenCode: localStorage.getItem("staffCode"),
      salesmanOptions: [],
      billPrefix: null,
      grate: null,
      billData: {},
      itemz: [],
      datareload: false,
      addcat2: false,
      purity: null,
      oldstoneweight: null,
      oldstoneprice: null,
      oldlessweight1: null,
      oldlessweight2: null,
      oldgrossweight: null,
      oldnetweight: null,
      oldprice: null,
      oldtotal: null,
      tax: null,
      saleweight: null,
      saleamount: null,
      oldfinalTotal: null,
      returnbillno: null,
      returndate: null,
      juwellaryId: localStorage.getItem("juwellaryId"),
      returnsalesId: null,
      returndata: [],
      olditems: [],
      categoryList: [],
      itempresent: false,
      returnbillNo: null,
      returncustomerName: null,
      returnstaffCode: null,
      returnTotalAmt: 0,
      returnNetWt: 0,
      customerList: [],
      returngoldRate: "",
      cid: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      phoneRules: [
        (v) => !!v || "Phone is required",
        (v) => (v && v.length <= 10) || "Invalid number",
        (v) => (v && v.length >= 10) || "Invalid number",
        (v) => /^\d{10}$/.test(v) || "Must be 10 digits",
      ],
      panRules: [
        (value) => !value || /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value) || "Invalid PAN number.",
      ],
      aadhaarRules: [
        (value) => !value || /^\d{12}$/.test(value) || "Invalid Aadhaar number.",
      ],
      pinRules: [
        (value) => !value || /^\d{6}$/.test(value) || "Invalid PIN number.",
      ],
      preview: false,
      previewList1: [],
      previewList2: [],
      previewList3: [],
      previewList4: [],
      previewList5: [],
      saleTTL: "",
      newTotal: "",
    };
  },
  beforeMount() {
    this.billId = this.$route.query.no;
    this.estno = this.$route.query.billno;
    this.getCustomer();
    this.getBill();
    this.userinfo();
    this.getSalesmanList();
  },
  watch: {
    billData() {
      this.customerName = this.billData.customerId;
      this.address = this.billData.customerId.address;
      this.city = this.billData.customerId.city;
      this.contact = this.billData.customerId.mobileNumber;
      if (this.billData.staffCode) {
        this.salesmenCode = this.billData.staffCode;
      }
      if (this.billData.billPrefix) {
        this.billPrefix = this.billData.billPrefix;
      }
    },
    cid() {
      this.customerName = this.cid;
      this.customerdetails();
    },
  },
  computed: {
    taxType() {
      return localStorage.getItem("GSTstatus");
    },
  },
  methods: {
    resetForm() {
      this.$refs.addcat.reset();
    },
    userinfo() {
      axios({
        method: "GET",
        url: "/user/info",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: localStorage.getItem("id"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            var check = response.data.goldrateadded;
            if (check == false) {
              this.queryPopUpDialog = true;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    winStepper(item) {
      if (item.ref == "itemData") {
        this.grate = item.boardingRate;
        this.itemz = item.items;
        this.addItem();
      }
      if (item.ref == "customerData") {
        if (item.saledata) {
          this.billData = item.saledata;
        }
      }
      if (item.ref == "returnItems") {
        if (item.returndata || item.returnsalesId) {
          this.returngoldRate = item.returngoldRate;
          this.returnTotalAmt = item.returnTotalAmt;
          this.returnNetWt = item.returnNetWt;
          this.returndata = item.returndata;
          this.returnsalesId = item.returnsalesId;
          this.returnbillNo = item.billNo;
          this.returncustomerName = item.customerName;
          this.returnstaffCode = item.staffCode;
        }
      }
      if (item.ref == "itempresent") {
        if (item.itempresent) {
          this.itempresent = item.itempresent;
        }
      }
    },
    validate() {
      if (!this.customerName) {
        this.msg = "Please enter customer name";
        this.showsnackbar = true;
      } else if (!this.contact) {
        this.msg = "Please enter contact number";
        this.showsnackbar = true;
      } else {
        this.getpreviewbill();
        this.preview = true;
      }
    },
    calctotal() {
      this.newTotal = 0;
      this.saleTTL = 0;
      if (this.taxType == "true") {
        this.saleTTL = this.previewList2.totalAmountWithGst;
      } else {
        this.saleTTL = this.previewList2.totalAmountWithoutGst;
      }
      if (this.previewList2.oldGoldAmount) {
        this.saleTTL = this.saleTTL - this.previewList2.oldGoldAmount;
      }
      if (this.returnTotalAmt) {
        this.saleTTL = this.saleTTL - this.returnTotalAmt;
      }
      var ttl = this.saleTTL.toFixed(2);
      this.newTotal = ttl;
    },
    getSalesmanList() {
      axios({
        method: "get",
        url: "/staff/salesmanlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.salesmanOptions = response.data.data.map((staff) => ({
              staffCode: staff.staffCode,
              label: staff.firstname + " " + (staff.lastname || "") + " (" + staff.staffCode + ")",
            }));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getBill() {
      this.estno = this.$route.query.billno;
      this.datareload = true;
    },
    addItem() {
      this.datareload = false;
      axios({
        url: "/sales/add",
        method: "POST",
        data: {
          items: this.itemz,
          goldRate: this.grate,
          billPrefix: this.billPrefix,
          customerId: this.customerName,
          address: this.address,
          city: this.city,
          mobileNumber: this.contact,
          date: this.date,
          billNo: this.estno,
          isEdit: true,
          staffCode: this.salesmenCode,
          jewelleryId: this.juwellaryId,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.datareload = true;
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.datareload = true;
          } else if (response.data.status == false && response.data.isExist == true) {
            this.msg = "Bill used by another user";
            this.showsnackbar = true;
            setTimeout(() => { location.reload(); }, 2000);
          } else {
            this.datareload = true;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    saveBill() {
      this.datareload = false;
      axios({
        url: "/sales/generate",
        method: "POST",
        data: {
          customerId: this.customerName,
          returngoldRate: this.returngoldRate,
          saleId: this.billData._id,
          returnSaleId: this.returnsalesId,
          currentReturnItems: this.returndata,
          billNo: this.returnbillNo,
          staffCode: this.returnstaffCode,
          jewelleryId: this.juwellaryId,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.datareload = true;
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.$router.push("/SalesList");
          } else {
            this.datareload = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getCustomer(keyword) {
      axios({
        method: "get",
        url: "/customer/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: keyword ? { keyword: keyword } : {},
      })
        .then((response) => {
          if (response.data.status == true) {
            this.customerList = response.data.data;
            this.Pagelength = Math.ceil(response.data.count / 20);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    searchCustomerByKeyword(keyword) {
      clearTimeout(this._customerSearchTimeout);
      this._customerSearchTimeout = setTimeout(() => {
        this.getCustomer(keyword);
      }, 300);
    },
    customerFilter(item, queryText) {
      var text = queryText ? queryText.toLowerCase() : "";
      var name = (item.customerName || "").toLowerCase();
      var phone = (item.mobileNumber || "").toLowerCase();
      return name.includes(text) || phone.includes(text);
    },
    customerdetails() {
      axios({
        method: "get",
        url: "/customer/view",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.customerName,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.address = response.data.data.address;
            this.city = response.data.data.city;
            this.contact = response.data.data.mobileNumber;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addCustomer() {
      axios({
        url: "/customer/add",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          jewelleryId: this.juwellaryId,
          customerName: this.newCustomer,
          address: this.newAddress,
          city: this.newCity,
          mobileNumber: this.newContact,
          pinNumber: this.newpinNumber,
          customerPAN: this.newCustomerPAN,
          customerAadhar: this.newCustomerAadhar,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.cid = response.data.data._id;
            this.customerdetails();
            this.getCustomer();
            this.addcustomerdialogue = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getpreviewbill() {
      axios({
        method: "get",
        url: "/sales/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          saleId: this.billData._id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.previewList1 = response.data.data;
            this.previewList2 = response.data.saledata;
            this.getpreviewbill2();
            this.getpreviewbill3();
            this.calctotal();
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getpreviewbill2() {
      axios({
        method: "get",
        url: "/oldgolditem/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          salesId: this.billData._id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.previewList3 = response.data.data;
            this.previewList4 = response.data.bill;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getpreviewbill3() {
      axios({
        method: "get",
        url: "/returnitem/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          salesId: this.billData._id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.previewList5 = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    EditRate() {
      axios({
        url: "/boardingrate/update",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          jewelleryId: this.juwellaryId,
          gold: this.gold,
          thankamRate: this.thankamRate,
          silverRate: this.silverRate,
          platinumRate: this.platinumRate,
          diamond: this.diamond,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.queryPopUpDialog = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      if (!item) return "-";
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      return day + " " + dt.slice(4, 7) + " " + year;
    },
  },
};
</script>

<style scoped>
.estimate-page-wrapper {
  background-color: transparent;
  min-height: 100vh;
  padding: 12px 16px 80px 16px;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.estimate-header-card {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
}

.header-back-btn {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}

.estimate-title-tag {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.5px;
}

.estimate-prefix-field {
  max-width: 90px;
}

.estimate-prefix-field :deep(.v-input__slot) {
  min-height: 34px !important;
  border-radius: 6px !important;
  background: #ffffff !important;
}

.estimate-number-pill {
  display: inline-flex;
  align-items: center;
  font-family: monospace;
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 5px 12px;
  border-radius: 6px;
  height: 34px;
}

.estimate-date-badge {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 6px 12px;
  border-radius: 6px;
  height: 34px;
}

.salesman-container {
  width: 200px;
}

.salesman-select :deep(.v-input__slot) {
  min-height: 34px !important;
  border-radius: 6px !important;
  font-size: 12px !important;
}

.customer-card {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
}

.customer-card-header {
  background-color: #f8fafc;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.card-heading {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  letter-spacing: 0.2px;
}

.customer-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

@media (max-width: 959px) {
  .customer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 599px) {
  .customer-grid {
    grid-template-columns: 1fr;
  }
}

.erp-field-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  margin-bottom: 4px;
}

.erp-field :deep(.v-input__slot) {
  min-height: 38px !important;
  background: #ffffff !important;
  border-radius: 6px !important;
}

.erp-field :deep(fieldset) {
  border-color: #cbd5e1 !important;
}

.erp-field:hover :deep(fieldset) {
  border-color: #94a3b8 !important;
}

.erp-field.v-input--is-focused :deep(fieldset) {
  border-color: #9a6b27 !important;
  border-width: 1.5px !important;
}

.erp-readonly :deep(.v-input__slot) {
  background-color: #f8fafc !important;
}

.erp-btn-secondary {
  border-color: #cbd5e1 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
}

.erp-btn-secondary:hover {
  background-color: #f1f5f9 !important;
}

.generate-estimate-btn {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  background-color: #9a6b27 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  border-radius: 10px !important;
  letter-spacing: 0.3px !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
  transition: all 0.25s ease !important;
}

.generate-estimate-btn:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1.5px) !important;
}

.erp-modal-card {
  background: #ffffff !important;
}

.modal-top-bar {
  background-color: #f8fafc;
}

.modal-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.modal-subtext {
  font-size: 12px;
  color: #64748b;
}

.required-star {
  color: #ef4444;
}

.erp-action-btn {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  background-color: #9a6b27 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  border-radius: 10px !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
  transition: all 0.25s ease !important;
}

.erp-action-btn:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1.5px) !important;
}

.preview-page-card {
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
}

.preview-header {
  background: #ffffff;
}

.preview-title {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #0f172a;
}

.preview-scroll-area {
  overflow-y: auto;
  flex: 1;
}

.preview-info-card {
  background: #ffffff !important;
  border-color: #e2e8f0 !important;
}

.preview-info-heading {
  font-size: 13px;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.preview-info-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 13px;
  padding: 6px 0;
  border-bottom: 1px solid #f8fafc;
}

.preview-info-row:last-child {
  border-bottom: none;
}

.info-label {
  width: 140px;
  min-width: 140px;
  flex-shrink: 0;
  color: #64748b;
  font-weight: 500;
}

.info-val {
  color: #0f172a;
  font-weight: 600;
  flex: 1;
  word-break: break-word;
}

.preview-table-title {
  font-size: 13px;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.preview-table th {
  background-color: #f8fafc !important;
  color: #475569 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

.preview-total-card {
  background: #ffffff !important;
  border-color: #e2e8f0 !important;
  min-width: 320px;
}

.summary-label {
  font-size: 13px;
  color: #64748b;
}

.summary-value {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.net-total-label {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.net-total-value {
  font-size: 16px;
  font-weight: 800;
  color: #9a6b27;
}

.text-success {
  color: #16a34a !important;
}

.border-t {
  border-top: 1px solid #e2e8f0;
}

/* ---- Phones ---- */
@media (max-width: 600px) {
  .preview-head-bar {
    padding-left: 16px !important;
    padding-right: 8px !important;
  }
  .preview-body {
    padding: 12px !important;
  }
  .preview-total-card.preview-total-wrap {
    width: 100%;
    min-width: 0 !important;
  }
  .preview-actions {
    flex-direction: column-reverse;
    align-items: stretch !important;
    width: 100%;
    gap: 8px;
  }
  .preview-actions .v-btn {
    width: 100%;
    margin-right: 0 !important;
  }
  .preview-info-row {
    flex-wrap: wrap;
    gap: 2px 8px;
  }
  .salesman-container {
    width: 100%;
  }
}
</style>
